<script setup lang="ts">
import Task from '@/core/resources/Task'
import { StatusTask } from '@/core/Common'
import { popupUtil } from '@/utils/Popup'

const props = defineProps({
  task: {
    type: Object as () => Task,
    required: true
  }
})
const selected = defineModel<boolean>()

const showError = async () => {
  await popupUtil.alert(props.task.last_error)
}
</script>

<template>
  <tr
    :class="{
      selected: selected,
      running: task.status === StatusTask.RUNNING,
      failed: task.status === StatusTask.FAILED,
      success: task.status === StatusTask.SUCCESS,
      waiting: task.status === StatusTask.WAITING
    }">
    <td>
      <input type="checkbox" v-model="selected" />
    </td>
    <td class="status-column">
      <span>{{ task.status }}</span>
    </td>
    <td class="name-column error" @click="showError" v-if="task.status === StatusTask.FAILED">
      {{ task.name }}
    </td>
    <td class="name-column" v-else>
      {{ task.name }}
    </td>
    <td>
      <span>{{ task.run_at.toLocaleDateString() }} {{ task.run_at.toLocaleTimeString() }}</span>
    </td>
    <td>
      <span>{{ task.username }}</span>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';

td {
  &.status-column {
    width: 100px;
  }

  &.name-column {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.error {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

tr {
  height: 24px;

  &.success {
    background-color: var(--theme-success);
  }

  &.failed {
    background-color: var(--theme-error);
  }

  &.running {
    background-color: var(--theme-info);
  }

  &.waiting {
    background-color: var(--theme-warning);
  }

  &:hover {
    background-color: var(--theme-panel-secondary);
  }
}
</style>
